import { useState, useEffect } from 'react';
import { supabase } from '../config/supabaseClient';
import { blogPosts as staticPosts, blogCategories as staticCategories } from '../data/blogPosts';

function mapRowToPost(row) {
  if (!row) return null;
  return {
    id: row.id || '',
    slug: row.slug || '',
    title: row.title || '',
    snippet: row.snippet || '',
    excerpt: row.excerpt || '',
    category: row.category || '',
    date: row.date || '',
    readTime: row.read_time || row.readTime || '5 min read',
    featured: row.featured || false,
    image: row.image || '',
    body: row.body || [],
  };
}

export function useBlogPosts() {
  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState(['All']);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const fetchPosts = async () => {
      try {
        setLoading(true);
        setError(null);

        const { data, error: fetchError } = await supabase
          .from('blog_posts')
          .select('*')
          .order('created_at', { ascending: false });

        if (fetchError) {
          console.warn('Supabase fetch error, falling back to static data:', fetchError.message);
          if (!mounted) return;
          setPosts(staticPosts);
          setCategories(staticCategories);
          setError(fetchError.message);
        } else if (data && data.length > 0) {
          const mapped = data.map(mapRowToPost);
          if (!mounted) return;
          setPosts(mapped);
          // Extract unique categories from DB
          const cats = ['All', ...new Set(mapped.map((p) => p.category).filter(Boolean))];
          setCategories(cats);
        } else {
          if (!mounted) return;
          setPosts(staticPosts);
          setCategories(staticCategories);
        }
      } catch (err) {
        console.error('Error in useBlogPosts:', err);
        if (!mounted) return;
        setPosts(staticPosts);
        setCategories(staticCategories);
        setError(err.message || String(err));
      } finally {
        if (!mounted) return;
        setLoading(false);
      }
    };

    fetchPosts();
    return () => { mounted = false; };
  }, []);

  return { posts, categories, loading, error };
}